import React from 'react'
import styled from 'styled-components'
import { ServiceForm } from '../components'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: auto;
  padding-bottom: 140px;
  @media screen and (max-width: 1023px) {
    padding-bottom: 120px;
  }
  @media screen and (max-width: 800px) {
    padding-bottom: 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 68%;
  max-width: var(--max-width);
  margin: 0 auto;
  text-align: center;
  h2.service-title {
    margin-bottom: 15px;
  }
  h3.service-subtitle {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`
const FormContainer = styled.div`
  display: block;
`
const ServiceContact = () => {
  return (
    <SectionWrapper>
      <SectionContainer>
        <HeaderContainer>
          <h2 className="service-title">Get a free quote</h2>
          <h3 className="service-subtitle">Getting a free quote is a great way to get an idea of how much a service will cost. It's a simple process that can save you time and money. All you have to do is provide some basic information about the service you're interested in, and I'll provide you with an estimate of the cost.</h3>
        </HeaderContainer>
        <FormContainer className="shopify-form">
          <ServiceForm />
        </FormContainer>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default ServiceContact
